import {defineMessage} from 'react-intl';
import html from './web/html/html';
import css from './web/html/css';
import js from './web/html/js';
import htmlSteps from './web/html/steps';
import ruby, {steps as rubySteps} from './server/ruby';
import python, {steps as pythonSteps} from './server/python';
import node, {steps as nodeSteps} from './server/node';
import php, {steps as phpSteps} from './server/php';
import java, {steps as javaSteps} from './server/java';
import go, {steps as goSteps} from './server/go';
import dotnet, {steps as dotnetSteps} from './server/dotnet';
import phpSave from './server/php-save';
import checkoutForm from './web/react/checkout-form';
import app from './web/react/app';
import appCss from './web/react/app-css';
import reactSteps from './web/react/steps';
import objcH from './ios/objc/objc-h';
import objcM from './ios/objc/objc-m';
import objSteps from './ios/objc/steps';
import swift from './ios/swift/swift';
import swiftSteps from './ios/swift/steps';
import gradle from './android/gradle';
import kotlin from './android/kotlin/kotlin';
import kotlinSteps from './android/kotlin/steps';
import javaclient from './android/java/javaclient';
import androidSteps from './android/java/steps';
import xml from './android/kotlin/xml';
import docs from './build';
import MyApp from './android/kotlin/MyApp';

export const sections = [
  {
    id: 'setup-stripe',
    heading: {
      message: defineMessage({
        id: 'docsApp.ib.aap.index.setupStripe',
        defaultMessage: 'Set up the server',
      }),
    },
    active: true,
  },
  {
    id: 'build-checkout-page',
    heading: {
      message: defineMessage({
        id: 'docsApp.ib.aap.index.buildTheCheckoutPage',
        defaultMessage: 'Build a checkout page on the client',
      }),
    },
  },
  {
    id: 'complete-the-payment',
    heading: {
      message: defineMessage({
        id: 'docsApp.ib.aap.index.completeThePayment',
        defaultMessage: 'Complete the payment on the client',
      }),
    },
  },
  {
    id: 'test-the-integration',
    heading: {
      message: defineMessage({
        id: 'docsApp.ib.aap.index.testThePayment',
        defaultMessage: 'Test the integration',
      }),
    },
  },
];

export const integrations = {
  docs,
  html: {
    steps: htmlSteps,
    files: {
      html: {
        builder: html,
        language: 'html',
        name: 'public/checkout.html',
      },
      js: {builder: js, language: 'js', name: 'public/client.js'},
      css: {builder: css, language: 'css', name: 'public/global.css'},
    },
  },
  react: {
    steps: reactSteps,
    files: {
      app: {
        builder: app,
        language: 'jsx',
        name: 'src/App.jsx',
      },
      checkoutForm: {
        builder: checkoutForm,
        language: 'jsx',
        name: 'src/CheckoutForm.jsx',
      },
      appCss: {
        builder: appCss,
        language: 'css',
        name: 'src/App.css',
      },
    },
  },
  swift: {
    files: {
      swift: {
        builder: swift,
        language: 'swift',
        name: 'CheckoutViewController.swift',
      },
    },
    steps: swiftSteps,
  },
  objc: {
    files: {
      objcH: {
        builder: objcH,
        language: 'objectivec',
        name: 'CheckoutViewController.h',
      },
      objcM: {
        builder: objcM,
        language: 'objectivec',
        name: 'CheckoutViewController.m',
      },
    },
    steps: objSteps,
  },
  kotlin: {
    files: {
      kotlin: {
        builder: kotlin,
        language: 'clike',
        name: 'CheckoutActivity.kt',
      },
      app: {
        builder: MyApp,
        language: 'clike',
        name: 'MyApp.kt',
      },
      xml: {
        builder: xml,
        language: 'xml',
        name: 'activity_checkout.xml',
      },
      gradle: {
        builder: gradle,
        language: 'groovy',
        name: 'build.gradle',
      },
    },
    steps: kotlinSteps,
  },
  javaclient: {
    files: {
      javaclient: {
        builder: javaclient,
        language: 'java',
        name: 'CheckoutActivityJava.java',
      },
      app: {
        builder: MyApp,
        language: 'clike',
        name: 'MyApp.java',
      },
      xml: {
        builder: xml,
        language: 'xml',
        name: 'checkout.xml',
      },
    },
    steps: androidSteps,
  },
  ruby: {
    files: {
      ruby: {
        builder: ruby,
        language: 'ruby',
        name: 'server.rb',
      },
    },
    steps: rubySteps,
  },
  node: {
    files: {
      node: {
        builder: node,
        language: 'js',
        name: 'server.js',
      },
    },
    steps: nodeSteps,
  },
  python: {
    files: {
      python: {
        builder: python,
        language: 'python',
        name: 'server.py',
      },
    },
    steps: pythonSteps,
  },
  php: {
    files: {
      php: {
        builder: php,
        language: 'php',
        name: 'create.php',
      },
      phpSave: {
        builder: phpSave,
        language: 'php',
        name: 'charge.php',
        extension: 'save-card',
      },
    },
    steps: phpSteps,
  },
  java: {
    files: {
      java: {
        builder: java,
        language: 'java',
        name: 'src/com/stripe/sample/Server.java',
      },
    },
    steps: javaSteps,
  },
  go: {
    files: {
      go: {
        builder: go,
        language: 'go',
        name: 'server.go',
      },
    },
    steps: goSteps,
  },
  dotnet: {
    files: {
      dotnet: {
        builder: dotnet,
        language: 'dotnet',
        name: 'Server.cs',
      },
    },
    steps: dotnetSteps,
  },
};

export default {
  integrations,
  sections,
};
